import React, { lazy } from 'react';
import EuPostRegistrationRedirect from '@sections/eu-post-registration-redirect/eu-post-registration-redirect';
import { GlobalAccountRoute } from './routesList';
import AppConfigurationService from '@services/app-configuration-service/app-configuration-service';

const EmailChannelPreferenceView = lazy(
    () =>
        import(
            '@views/email-channel-preferences-view/email-channel-preferences-view'
        )
);

const ChangeEmailView = lazy(
    () => import('@views/change-email-view/change-email-view')
);

const ConnectedServicesView = lazy(
    () => import('@views/connected-services-view/connected-services-view')
);

const MarketingOptionsView = lazy(
    () => import('@views/marketing-options-view/marketing-options-view')
);

const CommunicationPreferencesView = lazy(
    () =>
        import(
            '@views/communication-preferences-view/communication-preferences-view'
        )
);

const DeleteAccountView = lazy(
    () => import('@views/delete-account-view/delete-account-view')
);

const SignInCredentialsView = lazy(
    () => import('@views/sign-in-credentials-view/sign-in-credentials-view')
);

const CountrySelectorView = lazy(
    () => import('@views/country-selector-view/country-selector-view')
);

const PreferredDealerView = lazy(
    () => import('@views/preferred-dealer-view/preferred-dealer-view')
);

const VehicleOrderTrackingView = lazy(
    () =>
        import('@views/vehicle-order-tracking-view/vehicle-order-tracking-view')
);

const VehicleOrderTrackingStatusView = lazy(
    () =>
        import(
            '@views/vehicle-order-tracking-status-view/vehicle-order-tracking-status-view'
        )
);

const OrderHistoryView = lazy(
    () => import('@/views/order-history-view/order-history-view')
);

const GuestOrderView = lazy(
    () => import('@views/guest-login-views/guest-order-view/guest-order-view')
);

const ReturnConfirmationView = lazy(
    () => import('@views/return-confirmation-view/return-confirmation-view')
);

const GuestReturnView = lazy(
    () => import('@views/guest-login-views/guest-return-view/guest-return-view')
);

const AccountDashboardView = lazy(
    () => import('@/views/account-dashboard-view/account-dashboard-view')
);

const WalletView = lazy(() => import('@/views/wallet-view/wallet-view'));

const OrderDetailsView = lazy(
    () => import('@views/order-details-view/order-details-view')
);

const CreateReturnView = lazy(
    () => import('@views/create-return-view/create-return-view')
);

const OwnershipDelinkingView = lazy(
    () => import('@views/ownership-delinking-view/ownership-delinking-view')
);

const PageNotFoundView = lazy(
    () => import('@/views/page-not-found-view/page-not-found-view')
);

const AccountSettingsView = lazy(
    () => import('@views/account-settings-view/account-settings-view')
);

const CommunicationCenterView = lazy(
    () => import('@/views/communication-center-view/communication-center-view')
);

const ReturnToDealer = lazy(
    () => import('@views/return-to-dealer/return-to-dealer-view')
);

const SingleOrderTrackingView = lazy(
    () => import('@views/single-order-tracking-view/single-order-tracking-view')
);

const currentAppConfiguration =
    new AppConfigurationService().getAppConfiguration();
const appConfigRoot = currentAppConfiguration.root;

export const DEFAULT_ROUTES: Array<GlobalAccountRoute> = [
    {
        path: '/',
        exact: true,
        alias: 'GlobalAccountHomePage',
        component: <AccountDashboardView />,
    },
    {
        path: `${appConfigRoot}`,
        exact: true,
        alias: 'GlobalAccountHomePage',
        component: <AccountDashboardView />,
    },
    {
        path: '/account-dashboard',
        exact: true,
        alias: 'AccountDashboardView',
        component: <AccountDashboardView />,
    },
    {
        path: '/account-settings',
        exact: true,
        alias: 'AccountSettingsView',
        component: <AccountSettingsView />,
    },
    {
        path: '/email-preference',
        exact: true,
        alias: 'EmailChannelPreferenceView',
        component: <EmailChannelPreferenceView />,
    },
    {
        path: '/change-email',
        exact: true,
        alias: 'ChangeEmailView',
        component: <ChangeEmailView />,
    },
    {
        path: '/delete-account',
        exact: true,
        alias: 'DeleteAccountView',
        component: <DeleteAccountView />,
    },
    {
        path: '/wallet',
        exact: true,
        alias: 'WalletView',
        component: <WalletView />,
    },
    {
        path: '/connected-services',
        exact: true,
        alias: 'ConnectedServicesView',
        component: <ConnectedServicesView />,
    },
    {
        path: '/marketing-options',
        exact: true,
        alias: 'MarketingOptionsView',
        component: <MarketingOptionsView />,
    },
    {
        path: '/communication-preference',
        exact: true,
        alias: 'CommunicationPreferenceView',
        component: <CommunicationPreferencesView />,
    },
    {
        path: '/communication-center',
        exact: true,
        alias: 'CommunicationCenterView',
        component: <CommunicationCenterView />,
    },
    {
        path: '/eu-post-registration',
        exact: true,
        alias: 'EuPostRegistrationRedirect',
        component: <EuPostRegistrationRedirect />,
    },
    {
        path: '/signin-credentials',
        exact: true,
        alias: 'SignInCredentialsView',
        component: <SignInCredentialsView />,
    },
    {
        path: '/country-selector',
        exact: true,
        alias: 'CountrySelectorView',
        component: <CountrySelectorView />,
    },
    {
        path: '/preferred-dealer',
        exact: true,
        alias: 'PreferredDealerView',
        component: <PreferredDealerView />,
    },
    {
        path: '/order-details/:orderNo',
        exact: true,
        alias: 'OrderDetailsView',
        component: <OrderDetailsView />,
    },
    {
        path: '/order-details',
        exact: false,
        alias: 'OrderDetailsViewWithoutOrderNumber',
        component: <OrderDetailsView />,
    },
    {
        path: '/order-history',
        exact: true,
        alias: 'OrderHistoryView',
        component: <OrderHistoryView />,
    },
    {
        path: '/create-return',
        exact: true,
        alias: 'CreateReturnView',
        component: <CreateReturnView />,
    },
    {
        path: '/return-to-dealer',
        exact: true,
        alias: 'ReturnToDealer',
        component: <ReturnToDealer />,
    },
    {
        path: '/complete-return',
        exact: true,
        alias: 'ReturnConfirmationView',
        component: <ReturnConfirmationView />,
    },
    {
        path: '/vehicle-order-tracking',
        exact: true,
        alias: 'VehicleOrderTrackingView',
        component: <VehicleOrderTrackingView />,
    },
    {
        path: '/vehicle-order-tracking/status',
        exact: true,
        alias: 'VehicleOrderTrackingStatusView',
        component: <VehicleOrderTrackingStatusView />,
    },
    {
        path: '/guest-order',
        exact: true,
        alias: 'GuestOrderView',
        component: <GuestOrderView />,
    },
    {
        path: '/make-return',
        exact: true,
        alias: 'GuestReturnView',
        component: <GuestReturnView />,
    },
    {
        path: '/check-order-status',
        exact: true,
        alias: 'SingleOrderTrackingView',
        component: <SingleOrderTrackingView />,
    },
    {
        path: '/ownership-delinking/:data',
        exact: true,
        alias: 'OwnershipDelinkingView',
        component: <OwnershipDelinkingView />,
    },
    {
        path: '*',
        exact: true,
        alias: 'PageNotFoundView',
        component: <PageNotFoundView />,
    },
];
